import flatpickr from "flatpickr";
import { Japanese } from 'flatpickr/dist/l10n/ja';
import { DomComponentHander } from "./Handler";
export class DatePicker extends DomComponentHander {
    static DomContentLoaded() {
        document.querySelectorAll('input.datepicker').forEach(e => {
            flatpickr(e, {
                locale: Japanese,
                disableMobile: false,
                dateFormat: e.getAttribute('data-format') ?? ''
            });
        });
    }
}
